module.exports = __webpack_public_path__ + "media/default.86f5f489.mp3";